<template>
    <div>   
        <!-- <v-btn @click="TestCode()" color="success">text EIS INVENTORIES</v-btn> -->
        <v-container grid-list-xl> 
            <v-layout align-center="" justify-cmenter="">
                <v-col sm="12" cols="12">
                    <br>  
                    <v-card :min-height="vsh/2" > 
                        <v-card>
                            <mbs-page-tab 
                                :items="MY_LINKS"/>   
                        </v-card> 
                        <!-- <v-layout class="ma-5">
                            JOINING:
                            {{isJoining}}
                        </v-layout>
                        <v-layout class="ma-5">
                            CALCULATING:
                            {{isCalculating}}
                        </v-layout> -->
                        <mbs-item-manager
                            :table_title="`${ThisStockOutlet?.name} (${ThisStockOutlet?.eis||ThisStockOutlet?.code==0?'KPOS / EIS':'KPOS'}) Inventory`"
                            :table_title_icon="ThisStockOutlet?.icon"
                            :add_vertical_lines="true"
                            :row_click="true"
                            v-model="input"
                            :table_tabs="TABLE_TABS"
                            :top_label="false"
                            :name_items="ThisStockOutlet?ThisStockOutlet.name+' '+NAME_ITEMS:NAME_ITEMS"
                            :name_item="NAME_ITEM+'--'"
                            :value_items="VALUE_ITEMS"
                            :value_item="VALUE_ITEM"
                            :field_items="DATA.FIELDS.items"
                            :header_items="HEADER_ITEMS"
                            :header_items2="HEADER_ITEMS2"
                            :data_items="InventoryItems"  
                            :is_joined="true"  
                            :path_item="PATH_ITEM"  
                            :select_items="Selectors"  
                            :total_item_values="TOTAL_ITEM_VALUES"  

                            :table_actions="table_actions" 
                            @SELECT_TABLE_ACTION="TABLE_ACTION"
                            @SELECT_ITEM_ACTION="ITEM_ACTION"
                        />  
                    </v-card>
                    <br><br>
                </v-col>  
            </v-layout>
        </v-container>  

        <!-- //DIALOGS -->
        <div>
            <div v-if="ADDING_ITEM">
                <mbs-item-manager 
                    :show="false" 
                    :add_item_action="ADDING_ITEM.add_item_action"
                    :name_items="ADDING_ITEM.names"
                    :name_item="ADDING_ITEM.name"
                    :value_items="ADDING_ITEM.values"
                    :value_item="ADDING_ITEM.value"
                    :field_items="ADDING_ITEM.fields"   
                    :path_item="ADDING_ITEM.path"  
                    :select_items="Selectors"  
                    @ADDED="ADDED" 
                /> 
            </div>

           <!-- <mbs-stock-transfer 
                :from_outlet_code="stock_outlet_code"
           /> <mbs-stock-receive 
                :to_outlet_code="stock_outlet_code"
           />  -->

           <mbs-stock-inventory 
                :to_outlet_code="stock_outlet_code"
                :from_outlet_code="stock_outlet_code"
           /> 
        </div>
    </div> 
</template>

<script>
    import DATA, { production } from '../../../../plugins/DATA'
    import {mapState,mapGetters } from "vuex"
    import { mdiInvoiceTextPlusOutline } from '@mdi/js';
    import DB from '../../../../plugins/db/localDB';
    let PAGE_NAME = DATA.ITEMS.ITEMS.values    
    export default {
        name:PAGE_NAME, 
        props:['id','stock_outlet_code'], 
        data() {
            return {
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,
                input:{}, 
                input_transfer:{}, 
                dialog_transfer_stocks:false,
                dialog_transfer_select_items:false,
                dialog_receive_stock_option:false,
                menu_transfer_option:false,
                inputLoading:false,
                search_item:null,
                selected_item:null,
                selected_items:null,
                transfer_option:null,

                NAME_ITEMS:DATA.ITEMS.ITEMS.names,
                NAME_ITEM:DATA.ITEMS.ITEMS.name,
                VALUE_ITEMS:DATA.ITEMS.ITEMS.values,
                VALUE_ITEM:DATA.ITEMS.ITEMS.value, 
                ADDING_ITEM:null, 
                
                DATA:DATA,
                TOTAL_ITEM_VALUES:[ 
                    // {name:'Closing Stock (QTY)',value:'number_quantity',show_value:"number_quantity"},
                    // {name:'Total Cost',value:'number_total_cost',show_value:'number_total_cost_',money:true},
                    // {name:'Total Cost',value:'number_total_cost',show_value:'number_total_cost_',money:true},
                ], 
            }
        },
        created() {
            try { 
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
                this.MBS.events.$on('STOCK_SUBMITTED', this.STOCK_SUBMITTED);  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try {
                // console.log(this.SelectedCompany);
                this.MBS.actions.header({
                    show:true,
                    type:'subToolbar', 
                    images:null,
                    color:'black',
                    height:"300",
                    opacity:'0.1'
                }) 
                this.FEEDBACKS(1000)  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
            
        },
        computed: {
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vsh(){
                return this.vs.height
            }, 
            table_actions(){
                const stock_outlet_code = this.stock_outlet_code
                const settings = this.CompanySettings
                const eis = settings?.eis
                let refresh_name = "Refresh"
                if (eis && stock_outlet_code==0) {
                    refresh_name = "Refresh W."
                }else if (eis) {
                    refresh_name = "Refresh B."
                }
                let actions = [
                    {type:"action",btn:true,icon:"mdi-refresh",action:"refresh",color:"secondary", outlined:false,  text:refresh_name},   
                    
                    {type:"action",btn:true,icon:'mdi-tag',actions:[
                        {icon:"mdi-tag-plus",action:"create_item",text:'Create New Item'},
                        {icon:"mdi-tag",action:"manage_items",text:'Manage Items'},
                    ],color:"secondary", outlined:false,  text:"Items"},  
                    // {type:"action",btn:true,icon:'mdi-group',actions:[
                    //     {icon:"mdi-plus-box",action:"create_item_kit",text:'Create New Item Kit'},
                    //     {icon:"mdi-group",action:"manage_item_kit",text:'Manage Item Kits'},
                    // ],color:"secondary", outlined:false,  text:"Item Kit"}, 
                    {type:"action",btn:true,icon:'mdi-file-table-box',actions:[
                        {type:"btn",btn:true,icon:mdiInvoiceTextPlusOutline,color:"secondary", text:"Stock Requisition", min_width:"",action:"stock_requisition"} , 
                        {icon:"mdi-package-down",action:"receive_stocks",text:'Receive Stocks'},
                        {icon:"mdi-transfer",action:"transfer_stock",text:'Transfer Stocks'}, 
                        {type:"btn",icon:"mdi-cog-transfer",color:"secondary",  text:"Adjust Stock",action:"adjust_stock"}, 
                        {type:"btn",icon:"mdi-clipboard-search-outline",color:"secondary",  text:"Stock Taking",action:"stock_taking"}, 
                    ],color:"secondary", outlined:false,  text:"Manage Inventory"},   
                    {icon:"mdi-package-variant-plus",action:"receive_stock_page",text:'Receive Stock Page'},
                    {type:"action",icon:"mdi-contrast-box",action:"stock_control",text:'Move to Stock Control'},
                    {type:"action",icon:"mdi-warehouse",action:"warehouse",text:'Move to Warehouse'},
                    {type:"action",icon:"mdi-database-sync-outline",action:"sync_eis_to_kpos",color:"secondary", outlined:false,  text:"Sync EIS to KPOS"}, 
                    {type:"action",icon:"mdi-cloud-sync-outline",action:"sync_kpos_to_eis",color:"secondary", outlined:false,  text:"Sync KPOS to EIS"}, 
                    {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},  
                ]
                return actions

            },
            MY_LINKS(){  
                let outlets = this.StockOutletsData 
                
                if(!outlets){return null}
                let allLinks = []
                outlets.forEach(element => {
                    allLinks.push({
                        ...element,
                        name:element.name+" Inventory",
                        link:this.MBS.actions.COMPANY_LINK("/stock/manage/"+element.code,true),
                        // icon:'link',
                        // image:'/future_tours/svg/SVG/my_parcel.svg',
                        image_background_color:'primary lighten-2',
                        image_size:'80',
                        // indicator:{
                        //     color:'primary lighten-2',
                        //     value:"EIS"
                        // }
                        
                    })
                });  
                return allLinks
            }, 
            PATH_ITEM(){  
                let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.items,true) 
                return path
            },  
            TABLE_TABS(){
                const settings = this.CompanySettings
                const c_eis = settings?.eis
                const outlet = this.ThisStockOutlet 
                const eis = outlet?.code==0?c_eis:outlet?.eis

                const tabs1 =  [ 
                    {name:"Stock",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                            return !item.item_kits && stock
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},  
                    {name:"Out of Stock",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                            return !item.item_kits && !stock
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},  
                    // {name:"Kits",show_if:(this_,item)=>item.item_kits,indicator:{
                    //     color:'primary',
                    //     value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    // }}, 
                ]
                const tabs2 =  [ 
                    {name:"Stock",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                            let stock_eis = this.toNumber(item[this.stock_outlet_code+"_number_eis_quantity"])>0?true:false
                            return !item.item_kits && (stock || stock_eis)
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},  
                    {name:"K. Out of Stock",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                            return !item.item_kits && !stock
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }}, 
                    {name:"EIS. Out of Stock",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_eis_quantity"])>0?true:false
                            return !item.item_kits && !stock
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},   
                ]

                return eis?tabs2:tabs1
            },
            HEADER_ITEMS(){
                const outlet_code = this.stock_outlet_code
                
                const items = this.InventoryItems
                const received_items = items?.filter(i=>i[outlet_code+'_number_stock_receives'])
                const received = this.MBS.actions.SIZE(received_items)?true:false
                const transferred_items = items?.filter(i=>i[outlet_code+'_number_stock_transfers'])
                const transferred = this.MBS.actions.SIZE(transferred_items)?true:false
                const adjusted_items = items?.filter(i=>i[outlet_code+'_number_stock_adjustments'])
                const adjusted = this.MBS.actions.SIZE(adjusted_items)?true:false
                const sold_items = items?.filter(i=>i[outlet_code+'_number_sales'])
                const sold = this.MBS.actions.SIZE(sold_items)?true:false
                const returned_items = items?.filter(i=>i[outlet_code+'_number_returned_sales'])
                const returned = this.MBS.actions.SIZE(returned_items)?true:false
                const category_codes = items?.filter(i=>i.category_code)
                const has_category = this.MBS.actions.SIZE(category_codes)?true:false
                const department_codes = items?.filter(i=>i.item_department_code)
                const has_departments = this.MBS.actions.SIZE(department_codes)?true:false
                

                let input = this.input
                let current_table_tab = input?input.current_table_tab:null
                let tiers = this.AllPricingTiers
                let headers = [
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"No.",value:'no',show:false},  
                    {id:0,name:"",value:'icon_image',color:"",size:35,tile:true,show:true},   
                    {id:0,name:"Barcode",value:"code_",align:"center",show:true},   
                    {id:0,name:"Name",show:true}, 
                    {id:0,name:"Department",value:"item_department_name",cellClass:'',class:' b ',show:has_departments}, 
                    {id:0,name:"Department Code",value:"item_department_code",cellClass:'',class:' b ',show:false},
                    {id:0,name:"Category",value:"category_name",show:has_category}, 
                    {id:0,name:"Category Code",value:"category_code",show:false}, 
                    {id:0,name:"Brand",value:"brand_name",show:false}, 
                    {id:0,name:"Brand Code",value:"brand_code",show:false}, 
                    {id:0,name:"Manufacturers",value:"manufacturer_name",show:false}, 
                    {id:0,name:"Manufacturer Code",value:"manufacturer_code",show:false},
                    {id:0,name:"Item Cost Price",value:"cost_price_",show:false}, 
                ]

                if (tiers) {
                    tiers.forEach(tier => {
                        headers.push({
                           name:tier.name, 
                           value:tier.key, 
                           class:' b ',show:false
                        })
                    });
                } 

                if (current_table_tab==3) { 
                    headers.push(...[
                        // {id:0,name:"Open Stock",value:this.stock_outlet_code+"_all_opening_stocks",align:"center",show:true}, 
                        {id:0,name:"Ordered",value:this.stock_outlet_code+"_number_stock_receives",align:"center",show:false}, 
                        {id:0,name:"Return Stock",value:this.stock_outlet_code+"_number_stocks_return",align:"center",show:false}, 
                        {id:0,name:"Adjustments",value:this.stock_outlet_code+"_number_stock_adjustments",align:"center",show:false}, 
                        {id:0,name:"Return Sales",value:this.stock_outlet_code+"_number_returned_sales",align:"center",show:false}, 
                        {id:0,name:"Sold",value:this.stock_outlet_code+"_number_sales",align:"center",show:true},  
                        // {id:0,name:"Stock",value:this.stock_outlet_code+"_number_quantity",align:"center",show:true},   
                        {id:0,name:"Tax Group",value:"tax_group_name",align:"center",show:false}, 
                        {id:0,name:"Tax Group Code",value:"tax_group_code",align:"center",show:false},  
                    ])
                }else{ 
                    headers.push(...[
                        {id:0,name:"Open Stock",value:this.stock_outlet_code+"_all_opening_stocks",align:"center",show:true}, 
                        {id:0,name:"Received",value:this.stock_outlet_code+"_number_stock_receives",align:"center",show:received}, 
                        {id:0,name:"Transferred",value:this.stock_outlet_code+"_number_stock_transfers",align:"center",show:transferred}, 
                        {id:0,name:"Return Stock",value:this.stock_outlet_code+"_number_stocks_return",align:"center",show:returned}, 
                        {id:0,name:"Adjustments",value:this.stock_outlet_code+"_number_stock_adjustments",align:"center",show:adjusted}, 
                        {id:0,name:"Return Sales",value:this.stock_outlet_code+"_number_returned_sales",align:"center",show:false}, 
                        {id:0,name:"Sold",value:this.stock_outlet_code+"_number_sales",align:"center",show:sold},  
                        {id:0,name:"K. Stock",value:this.stock_outlet_code+"_number_quantity",align:"center",show:true},  
                        {id:0,name:"EIS. Stock",value:this.stock_outlet_code+"_number_eis_quantity",align:"center",show:true},  
                        {id:0,name:"Tax Group",value:"tax_group_name",align:"center",show:false}, 
                        {id:0,name:"Tax Group Code",value:"tax_group_code",align:"center",show:false},  
                    ])
                }
                headers.push({id:0,name:"action",align:"right",show:true,item:[  
                    {name:"Transfer Stock",action:"transfer_item_stock",icon:"mdi-transfer"}, 
                    {name:"Receive Stock",action:"receive_item_stock",icon:"mdi-package-down"}, 
                    {name:"Stock History",action:"transferred_item_history",icon:"mdi-clipboard-text-clock"},  
                ]}) 
                return headers
            },
            HEADER_ITEMS2(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"No.",value:'no',show:true},  
                    {id:0,name:"Barcode",value:"code",align:"center",show:true},      
                    {id:0,name:"Name",show:true}, 
                    {id:0,name:"Category",value:"category_code",show:true}, 
                    {id:0,name:"Brand",value:"brand_code",show:true}, 
                    {id:0,name:"Cost",value:"cost_price",show:true}, 
                    {id:0,name:"Retail",value:"retail_price",show:true}, 
                    {id:0,name:"Wholesale",value:"wholesale_price",show:true}, 
                    {id:0,name:"Tax",value:"tax",show:true}, 
                    {id:0,name:"action",align:"right",show:true,item:[  
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"mdi-pencil"},
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                    ]}, 
                ]
            }, 
            /////////
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                SelectedCompany: state=> state.items["SELECTED_COMPANY"],  
            }),
            ...mapState({
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                Brands: state=> state.items[(DATA.ITEMS.BRANDS.values).toUpperCase()],
                Manufacturers: state=> state.items[(DATA.ITEMS.MANUFACTURERS.values).toUpperCase()], 
                TaxGroups: state=> state.app[(DATA.ITEMS.TAX_GROUPS.values).toUpperCase()], 
                StockOutlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                JoinedStockOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],  
                PricingTiers: state=> state.items[(DATA.ITEMS.PRICING_TIERS.values).toUpperCase()], 
                JoinedPricingTiers: state=> state.join[(DATA.ITEMS.PRICING_TIERS.values).toUpperCase()], 
                DefaultPricingTiers: state=> state.app['DEFAULT_PRICING_TIERS'], 
                ReceiveStockOptions: state=> state.app['RECEIVE_STOCK_OPTIONS'], 
            }),  
            StockOutletsData(){ 
                let items = this.JoinedStockOutlets?this.JoinedStockOutlets:this.StockOutlets 
                return items
            }, 
            ToOutlets(){
                const outlets = this.StockOutlets
                const outlet_code = this.stock_outlet_code
                return outlets?.filter(item=>item.code !=outlet_code)
            },
            ItemsData(){ 
                const settings = this.CompanySettings
                const eis = settings?.eis

                let Items = this.Items
                let JoinedItems = this.JoinedItems
                let CalculatedItems = this.CalculatedItems 
                const all_items = JoinedItems?JoinedItems:Items
                console.log(all_items,"all_items.....");
                
                // if (eis) {
                //     // console.log(items,'m............');
                //     // let filtered = items?.filter(i=>i.is_mra_verified)
                //     // console.log(filtered,'2................');
                //     return filtered
                // } 

                
                return all_items
            },
            InventoryItems(){ 
                const items = this.ItemsData 
                const filtered = items?.filter(item=>{
                    const service = item.item_type_key == "service"
                    const child = item.item_type_key == "child"
                    const parent = item.item_type_key == "parent"
                    const inventory_item_code = item?.inventory_item_code
                    const inventory_item_key = item?.inventory_item_key
                    const inventory_item_keycode = inventory_item_key?inventory_item_key:inventory_item_code
                    const inventory = !inventory_item_keycode || inventory_item_keycode == "main"?true:false
                    return inventory && !service && !child && !parent
                })  
                return filtered
            },
            PricingTiersData(){
                return this.JoinedPricingTiers?this.JoinedPricingTiers:this.PricingTiers
            }, 
            AllPricingTiers(){
                let defaults = this.DefaultPricingTiers
                let tiers = this.PricingTiersData 
                let all = []
                if (defaults) {
                    all.push(...defaults)
                }if (tiers) {
                    tiers.forEach(tier => {
                        let index = all.findIndex(item=>item.key == tier.key)
                        if (index==-1) {
                            all.push(tier) 
                        } else {
                            all[index] = {
                                ...all[index],
                                ...tier
                            }
                        }
                    });
                }
                return all
            }, 
            ThisStockOutlet(){ 
                let stock_outlet_code = this.stock_outlet_code
                let outlets = this.StockOutletsData
                if(!outlets || !stock_outlet_code){return null}
                let item = outlets.find(outlet=>outlet.code == stock_outlet_code)
                return item
            },
            selectedCompany(){  
                return this.$store.getters.getSelectedCompany
            },  
            isCalculating(){  
                return this.$store.getters.isCalculating("ITEMS")
            },  
            isJoining(){  
                return this.$store.getters.isJoining("ITEMS")
            },  
            
            Selectors(){ 
                let Outlets = this.StockOutletsData 
                let ToOutlets = this.ToOutlets 
                let Items = this.ItemsData  
                let ItemCategories = this.ItemCategories
                let Brands = this.Brands
                let Manufacturers = this.Manufacturers
                let TaxGroups = this.TaxGroups
                let PricingTiers = this.AllPricingTiers
                let ReceiveStockOptions = this.ReceiveStockOptions

                console.log(Outlets,"Outlets.....");
                
                return{
                    Outlets: Outlets,
                    ToOutlets: ToOutlets,
                    Items: Items,
                    ItemCategories: ItemCategories,
                    Brands: Brands,
                    Manufacturers: Manufacturers, 
                    TaxGroups: TaxGroups, 
                    PricingTiers: PricingTiers, 
                    ReceiveStockOptions: ReceiveStockOptions, 
                }
            },
            
        },
        methods: {  
            async TestCode(){
                const res = await this.MBS.eis.ON_EIS_SYNC_INVENTORIES({ 
                    confirm:false,
                    notify:true,
                    update_name_by_description:true,
                    pricing_tiers:['wholesale_price'],
                })
                console.log(res,'res..............');
            },
            TABLE_ACTION(action,item){
                try {
                    let route = this.route
                    let fullPath = route?route.fullPath:null
                     console.log(action,'action');
                    if (action == "refresh") {
                        let mbs_text = this.MBS.text.item_action("Item Data","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            action:{
                                code:PAGE_NAME+"=RELOAD-ITEMS", 
                            } 
                        })
                    }else if (action == "create_item") {
                        this.CREATE_ITEM()
                    }else if (action == "create_item_kit") {
                        this.CREATE_ITEM_KIT()
                    }else if (action == "manage_items") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/items",true))
                    }else if (action == "manage_item_kit") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/item-kit",true))
                    }else if (action == "stock_requisition") {
                        this.STOCK_REQUISITION() 
                    }else if (action == "receive_stocks") {
                        this.RECEIVE_STOCK() 
                    }else if (action == "receive_stock_page") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/receive-stock",true))
                    }else if (action == "transfer_stock") {
                        this.TRANSFER_STOCK()
                    }else if (action == "adjust_stock") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/adjust-stock",true))
                    }else if (action == "stock_control") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control",true))
                    }else if (action == "stock_taking") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-take",true))
                    }else if (action == "warehouse") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/warehouse",true))
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            ITEM_ACTION(action,item,option){
                try {     
                    console.log(action,'***************');
                    if (action == "on_row_clicked") {
                         
                    }else if (action == "transfer_item_stock") {
                        this.TRANSFER_STOCK(item.key) 
                    }else if (action == "receive_item_stock") {
                        this.RECEIVE_STOCK(item.key) 
                    }else{}
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ITEM_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            async ADD_ITEM(item_key, item_code){
                try { 

                    console.log(item_key,item_code,);
                    this.FULLSCREEN() 
                    const settings = this.CompanySettings 
                    const activate_stock_level = settings?settings.activate_stock_level:null 

 
                    const outlet_code = this.stock_outlet_code
                    let quantity = null
                    let item_price = null 
                    let scales = this.Scales  
                    
                    const items = this.ItemsData 
                    const moment = this.MBS.date.moment
                    const selecting_list_key = moment?moment().valueOf():null

                    
                    
                    if (items) {
                        setTimeout(() => {
                            this.search_item=null 
                        }, 500);
                        let item_selected = items.find(item=>{
                            return  item_key?item.key == item_key:item.code == item_code
                        }) 
                        if (!item_selected) {
                            this.MBS.actions.dialog()
                            let isTimestamp = this.MBS.actions.isTimestamp(item_code)
                            if(isTimestamp){ 
                                console.log(item_code,'isTimestamp...')
                            }else{
                            }
                            setTimeout(() => {    
                                this.MBS.actions.dialogConfirmPassword({
                                    show:true,
                                    icon:mdiTagHidden,
                                    title:'ITEM NOT FOUND',
                                    text:"Item (" + item_code + ") not found. Please ensure that items are loaded and refreshed. Alternatively, you can use scanned barcode to add the item as new.",
                                    btnYes:"ADD AS NEW ITEM",
                                    btnNo:"REFRESH ITEMS",
                                    action:{
                                        code:PAGE_NAME+'=CREATE_AS_NEW_ITEM',
                                        item_code:item_code,
                                        silent_btn_no:true,
                                        phone_number_start:true,
                                        all_users:true,
                                        get_access:{
                                            permission_type:"action", 
                                            permission_to:"write", 
                                            action_name:DATA.ITEMS.ITEMS.names
                                        }
                                    }
                                }) 
                            }, 500); 
                            return 
                        } 
                        
                        //check stock level
                        if (activate_stock_level) {
                            
                            let stock_settings = await this.MBS.actions.CHECK_ITEM_STOCK_SETTINGS({
                                item:item_selected,
                                outlet_code:outlet_code,
                                notify:false
                            })

                            // console.log(stock_settings,'stock_settings-*---------------****');
                            
  
                            let allow_sell = stock_settings?stock_settings.allow_sell:null 
                            let stop_selling_level = stock_settings?stock_settings.stop_selling_level:null 
                            let quantity = stock_settings?stock_settings.quantity:null 
                            let stop_sale = quantity <= stop_selling_level?true:false
                            if (!allow_sell && stop_sale) {
                                await this.MBS.actions.CHECK_ITEM_STOCK_SETTINGS({
                                    item:item_selected,
                                    outlet_code:outlet_code,
                                    notify:true
                                })
                                return
                            } 
                        }


                        /// if array
                        let newItem = {
                            ...item_selected,  
                            quantity:quantity?quantity:1,
                        }

                       
                        console.log(newItem,'newItem......');

                        //display selected item
                        // this.CUSTOMER_DISPLAY({
                        //     type:'add_item',
                        //     item:newItem
                        // }) 

                        this.MBS.events.$emit("ADD_STOCK_TRANSFER_SELECTED_ITEMS",{
                            item_key:item_key,
                            item_code:item_code,  
                            selected_item:newItem,
                        }) 
                        return 
                    }
                     
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            STOCK_REQUISITION(item_key, item_code){
                try {  
                    this.MBS.events.$emit("INVENTORY_STOCK_REQUISITION",{
                        item_key:item_key,
                        item_code:item_code,   
                    })  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'STOCK_REQUISITION',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            RECEIVE_STOCK(item_key, item_code){
                try {  
                    console.log(item_key,item_code,);
                     this.MBS.events.$emit("INVENTORY_STOCK_RECEIVE",{
                        item_key:item_key,
                        item_code:item_code,   
                    })  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'RECEIVE_STOCK',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            TRANSFER_STOCK(item_key, item_code){
                try {  
                    console.log(item_key,item_code,);
                     this.MBS.events.$emit("INVENTORY_STOCK_TRANSFER",{
                        item_key:item_key,
                        item_code:item_code,   
                    })  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TRANSFER_STOCK',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            
            CONFIRM_CLEAR_SELECTED_ITEMS(){
                try {    
                    
                    let mbs_text = this.MBS.text.item_action("Selected Items","Clear") 
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        icon:"mdi-delete",
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+'=CLEAR-SELECTED-ITEMS', 
                            show_response:true
                        }
                    })   
                     
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_CLEAR_SELECTED_ITEMS',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            CLEAR_SELECTED_ITEMS(show_response){
                try {   
                    DB.deleteItems({
                        name:DATA.ITEMS.LOCAL_SELECTED_STOCK_ADJUSTMENTS.values, 
                        update_locals:true, 
                    }).then(res=>{
                        console.log(res,'res........');
                        this.MBS.actions.progressDialog()
                        if (show_response) {
                            let mbs_text = this.MBS.text.item_action_success("Selected Items","Clearing")
                            this.MBS.actions.dialog({
                                show:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes,
                                btnNo:mbs_text.btnNo, 
                            })     
                        }
                    }).catch(error=>{
                        console.log(error,'error...........');
                        this.MBS.actions.progressDialog()
                        if (show_response) {
                            let mbs_text = this.MBS.text.item_action_fail("Selected Items","Clearing")
                            this.MBS.actions.dialog({
                                show:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes,
                                btnNo:mbs_text.btnNo, 
                            }) 
                        }
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_CLEAR_SELECTED_ITEMS',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            CONTINUE_STOCK_TRANSFER(){
                try {  
                    this.input.from_outlet_code = this.stock_outlet_code? this.stock_outlet_code:null,
                    this.input.selected_items = this.selected_items? this.selected_items:null
                    this.dialog_transfer_select_items = false
                    this.dialog_transfer_stocks = true  
                    // setTimeout(() => {
                    // }, 100);
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONTINUE_STOCK_TRANSFER',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            BACK_STOCK_TRANSFER(){
                try {   
                    this.dialog_transfer_select_items = true
                    this.dialog_transfer_stocks = false   
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'BACK_STOCK_TRANSFER',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            SUBMIT_SOCK_TRANSFER(option){ 
                try { 
                    this.menu_transfer_option = false
                    this.transfer_option = option 
                    this.$refs.ref_btn_transfer_stock.$el.click();
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SEND_AND_PRINT_NEW_ORDER',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            CONFIRM_STOCK_TRANSFER(input,transfer_option){
                try {    
                    const ud = this.ud
                    const uid = ud?.uid
                    const company = this.selectedCompany
                    const company_key = company?.company_key
                    const moment = this.MBS.date.moment
                    const key = moment?moment().valueOf():null
                    const code = input?.code?input?.code:null
                    const from_outlet_code = input?.from_outlet_code?input?.from_outlet_code:null
                    const to_outlet_code = input?.to_outlet_code?input?.to_outlet_code:null
                    const transferred_date = input?.transferred_date?input?.transferred_date:null
                    const description = input?.description?input?.description:null
                    const selected_items = input?.selected_items?input?.selected_items:null
                    let dialog = this.MBS.actions.dialog
                    let items = []
                    let mbs_text = null
                    let error_text = null
                    selected_items?.forEach(item => {
                        items.push({
                            item_key:item._key,
                            item_code:item._code,
                            item_name:item.name,
                            item_cost_price:item.cost_price,
                            quantity:item.quantity, 
                            
                        })
                        
                    });
                    const data = {
                        order_type:DATA.ITEMS.STOCK_TRANSFERS.value,
                        code,from_outlet_code,
                        to_outlet_code,transferred_date,
                        description,items,
                        created_uid:uid,
                        company_key,
                        local_created_at:key,
                        transfer_option
                    }
                    if (from_outlet_code == to_outlet_code) {
                        error_text = 'Transfer to outlet should be different from Transfer from outlet. '
                    }

                    if (transfer_option == "send_for_approval") {
                        dialog = this.MBS.actions.dialogConfirmPassword
                        mbs_text = this.MBS.text.item_action("Stock Transfer for approval","Send") 
                    }else if (transfer_option == "direct_transfer") {
                        dialog = this.MBS.actions.dialogConfirmPassword
                        mbs_text = this.MBS.text.item_action("Stock","Direct Transfer") 
                    }else if (transfer_option == "send_for_verification") {
                        dialog = this.MBS.actions.dialogConfirmPassword
                        mbs_text = this.MBS.text.item_action("Stock Transfer for verification","send") 
                    }else if (transfer_option == "save_draft") {
                        mbs_text = this.MBS.text.item_action("Draft","Save") 
                    }else{
                        error_text = "Something went wrong. Please try again."
                    } 

                    if (error_text) {
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            icon:"mdi-alert",
                            title:"ERROR",
                            text:error_text,
                            btnYes:"OKAY", 
                        })  
                        return 
                    }

                    console.log(input,'input..............');
                    console.log(data,'data..............XXX');
 
                    dialog({
                        show:true,
                        fixed:true,
                        icon:"mdi-transfer",
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+'=SUBMIT-TRANSFER-STOCK', 
                            data,
                            phone_number_start:true,
                            all_users:true,
                            get_access:{
                                permission_type:"action", 
                                permission_to:"inventory", 
                                action_name:DATA.ITEMS.STOCK_TRANSFERS.names
                            }
                        }
                    })   
                     
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_STOCK_TRANSFER',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            SUBMIT_TRANSFER_ORDER(order,action){
                try {  
                    const order_code = order?.code
                    const uid = action?.ud?.uid
                    const transfer_option = order?.transfer_option 
                    let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_drafts+order_code,true) 
                    if (transfer_option =="send_for_approval") {
                        path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_requests+order_code,true)
                    }if (transfer_option =="send_for_verification") {
                        path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_requests+order_code,true)
                    }if (transfer_option =="direct_transfer") {
                        path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_orders+order_code,true)
                    }
                    if (uid) {
                        order.logged_uid = order.created_uid
                        order.created_uid = uid
                    }
                    if (!order_code || !path) {
                        console.log(order,'order error');
                    } 
                     console.log(path,'path------------**');
                     console.log(action,'action------------**');
                     console.log(order,'order------------**');
                     
                    this.inputLoading = true
                    this.MBS.actions.progressDialog({
                        show:true,
                        title:"Uploading..",
                    }) 
                    this.$store.dispatch("fi_update",{
                        action:DATA.ITEMS.STOCK_ORDERS.values,
                        data:order,
                        path:path
                    })
                    .then(res=>{
                        console.log(res,'re..................');
                        return  this.$store.dispatch('fi_tracker',{
                            company:this.selectedCompany,
                            names:[
                                {data_save:false,on:false,get:false,cash:true,name:DATA.ITEMS.ITEMS.values}, 
                            ]
                        }) 
                    })
                    .then(res=>{
                        this.inputLoading = false
                        this.dialog_transfer_select_items = false
                        this.dialog_transfer_stocks = false
                        this.MBS.actions.progressDialog() 
                        this.CLEAR_SELECTED_ITEMS()
                        let mbs_text = this.MBS.text.item_action_success(DATA.ITEMS.STOCKS.value,"Transferring")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes, 
                        })   
                        console.log(res,'re..................s');
                         
                    }).catch(error=>{
                        console.log(error,'err..................');
                        this.MBS.actions.progressDialog() 
                        this.MBS.actions.error({
                            error:error,
                            from:'SUBMIT_ORDER',
                            page:PAGE_NAME, 
                        })  
                        this.inputLoading = false
                        this.MBS.actions.progressDialog() 
                        let mbs_text = this.MBS.text.item_action_fail(DATA.ITEMS.STOCKS.value,"Transferring")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes, 
                        })  
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SUBMIT_TRANSFER_ORDER',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 
            
            CREATE_ITEM(input){
                try {     
                    this.ADDING_ITEM = {...DATA.ITEMS.ITEMS}
                    this.ADDING_ITEM.path =  this.MBS.actions.COMPANY_LINK(DATA.PATHS.items,true)
                    this.ADDING_ITEM.fields =  DATA.FIELDS.items
                    this.ADDING_ITEM.add_item_action =  {
                        action_do:'Create',
                        action_doing:'Creating'
                    }
                    setTimeout(() => {
                        this.MBS.events.$emit("ITEM_ACTION",{
                            NAME_ITEM:DATA.ITEMS.ITEMS.name,
                            action:"add_item",
                            input:{name:input}
                        }) 
                        console.log(this.ADDING_ITEM,'create item,,,......'); 
                    }, 50);
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CREATE_ITEM',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            CREATE_ITEM_KIT(input){
                try {     
                    this.ADDING_ITEM = {...DATA.ITEMS.ITEMS}
                    this.ADDING_ITEM.path =  this.MBS.actions.COMPANY_LINK(DATA.PATHS.items,true)
                    this.ADDING_ITEM.fields =  DATA.FIELDS.items_kit
                    this.ADDING_ITEM.add_item_action =  {
                        action_do:'Create',
                        action_doing:'Creating'
                    }
                    setTimeout(() => {
                        this.MBS.events.$emit("ITEM_ACTION",{
                            NAME_ITEM:DATA.ITEMS.ITEMS.name,
                            action:"add_item",
                            input:{name:input}
                        }) 
                        console.log(this.ADDING_ITEM,'create item,,,......'); 
                    }, 50);
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CREATE_ITEM_KIT',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            ADDED(res){
                try { 
                    this.RELOAD_ITEMS(null,true)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADDED',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            async RELOAD_ITEMS(outlet_codes,notify){
                try {
                    const stock_outlet_code = this.stock_outlet_code
                    const settings = this.CompanySettings
                    const eis = settings?.eis

                    let eis_message = ""
                    let company = this.SelectedCompany
                    let company_key = company?company.company_key:null
                    if (eis && stock_outlet_code == 0) {
                        if (notify) {
                            this.MBS.actions.progressDialog({
                                show:true,
                                text:"EIS Connecting..."
                            }) 
                        }
                        console.log('Start eis...........');
                        let data = {
                            company_key:company_key, 
                            production:DATA.EIS.production,  
                        }
                        let eis_res = await this.MBS.actions.POST_REQUEST({
                            action:this.VALUE_ITEM,
                            path:"eis-sync-warehouse-inventory",
                            data:data, 
                        })
                        const body = eis_res?.body
                        eis_message = body?.message
                        console.log(eis_res,'eis_res...........');
                        
                    }else if (eis && outlet_codes) {
                        for (const outlet_code of outlet_codes) {
                            const res = await this.MBS.eis.ON_SYNC_EIS_PRODUCTS({
                                stock_outlet_code:outlet_code,
                                confirm:false,
                                notify:notify
                            })  
                            const body = res?.body 
                        }
                        eis_message = `${this.MBS.actions.SIZE(outlet_codes)} outlet(s) updated.`
                    }else if (eis && stock_outlet_code) {
                        const res = await this.MBS.eis.ON_SYNC_EIS_PRODUCTS({
                            stock_outlet_code:this.stock_outlet_code,
                            confirm:false,
                            notify:notify
                        })  
                        const body = res?.body
                        eis_message = body?.message
                    }
                    if (notify) {
                        this.MBS.actions.progressDialog({
                            show:true,
                            text:"Updating..."
                        })
                        
                    }
                    const res = await this.$store.dispatch('fi_get_item',{
                        name:DATA.ITEMS.ITEMS.values,
                        on:false, 
                        cash:true, 
                        get:false, 
                        company_key:company_key, 
                    })  
                    console.log(res,'res.......');
                    this.MBS.actions.progressDialog()
                    if (notify) {
                        let mbs_text = this.MBS.text.item_action_success(DATA.ITEMS.ITEMS.values,"Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:`${mbs_text.text} (EIS:${eis_message})`,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        }) 
                    }
                } catch (error) {
                    console.log(error,'error.......');
                    this.MBS.actions.progressDialog()
                    if (notify) {
                        let mbs_text = this.MBS.text.item_action_fail(DATA.ITEMS.ITEMS.values,"Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        }) 
                    }
                }

            },

            FULLSCREEN(activate=true){  
                try {     
                    let always_on_fullscreen = true
                    let fullscreen = this.fullscreen
                    if (always_on_fullscreen) {
                        this.MBS.actions.SCREEN_FULL_MODE(true) 
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FULLSCREEN',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 

            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===PAGE_NAME+'=RELOAD-ITEMS') {
                            if (action.YES) {
                                this.RELOAD_ITEMS(null,true)
                            } else {
                                
                            }
                        }  
                        if (action.code ===PAGE_NAME+'=CLEAR-SELECTED-ITEMS') {
                            if (action.YES) {
                                this.CLEAR_SELECTED_ITEMS(action.show_response)
                            } else {
                                
                            }
                        } if (action.code ===PAGE_NAME+'=SUBMIT-TRANSFER-STOCK') {
                            if (action.YES) {
                                this.SUBMIT_TRANSFER_ORDER(action.data,action)
                            } else {
                                
                            }
                        }  
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },
            STOCK_SUBMITTED(order){ 
                try {
                    console.log(order,'STOCK_SUBMITTED.....');
                    let outlets = []
                    const from_outlet_code = order?.from_outlet_code
                    const to_outlet_code = order?.to_outlet_code
                    const receive_from_type = order?.receive_from_type
                    if (receive_from_type) {
                        outlets.push(receive_from_type)
                    }if (from_outlet_code) {
                        outlets.push(from_outlet_code)
                    }if (to_outlet_code) {
                        outlets.push(to_outlet_code)
                    }

                    this.RELOAD_ITEMS(outlets)
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'STOCK_SUBMITTED',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            FEEDBACKS(time){ 
                try {
                    if (!time) { time=400 }
                    setTimeout(()=>{
                        let us = this.loggedUser 
                        let ps = this.processes
                        let ld = this.loading
                        let res = this.responses

                        //Check process 
                        if (ps) {
                            let gettingItems = ps.find(process=>{
                                return process.name == 'getting/'+this.VALUE_ITEMS
                            })
                            if (!gettingItems) {
                                this.PAGE_LOAD =true
                            }  
                        }else{
                            this.PAGE_LOAD =true
                        } 
                    },time)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FEEDBACKS',
                        page:PAGE_NAME, 
                    })  
                } 
            },  
        },
        beforeDestroy(){
            try { 
                this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);    
                this.MBS.events.$off('STOCK_SUBMITTED', this.STOCK_SUBMITTED);    
                console.log("beforeDestroy-----------");
            } catch (error) {
                this.MBS.actions?.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch: {  
            search_item(value){ 
                if (value) { 
                    this.ADD_ITEM(value) 
                }
            }, 
            loading(value){
                this.FEEDBACKS(1)
            },
            processes(value){
                this.FEEDBACKS(1)
            },
            responses(value){
                this.FEEDBACKS(1) 
            }, 
            input_transfer(value){
                this.selected_items = value?.selected_items 
            }, 
        },
    }
</script>
 
